<template>
    <q-form @validationError="scrollTo" action="." ref="form" greedy>
        <slot/>
    </q-form>
</template>
<script>
export default {
    name: 'form-wrapper',
    props: {
        validateOnLoad: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        if (this.validateOnLoad) {
            this.validate();
        }
    },
    methods: {
        scrollTo(ref) {
            return ref.$el.scrollIntoView({
                behavior: 'smooth', block: 'start', inline: 'nearest',
            });
        },
        validate() {
            return this.$refs.form.validate();
        },
        reset() {
            return this.$refs.form.reset();
        },
    },
};
</script>
